import ExpandTransitionGenerator from './expand-transition';
import { createJavaScriptTransition } from '~/helpers';

export const HExpandTransition = createJavaScriptTransition(
  'h-expand-transition',
  ExpandTransitionGenerator(),
);
